module.exports = __webpack_public_path__ + "img/logo_login.0c0c0c76.png";